import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  i18n,
  render: function (h) { return h(App) }
}).$mount('#app')

import './assets/scss/master.scss';
import i18n from './i18n'
